export const GET_RESPONSE_LINKS_TYPE_FIELD_NAME = 'get_response_links_type'

export const GetResponseLinksTypeOptionValue = {
  Later: 'later',
  Wait: 'wait',
}

export const INITIAL_VALUES = {
  [GET_RESPONSE_LINKS_TYPE_FIELD_NAME]: GetResponseLinksTypeOptionValue.Later,
}
